import React, { useEffect, useState } from "react";
import _ from "lodash";
import { useRouteMatch } from "react-router-dom";

import { ERROR_MESSAGE_UNEXPECTED_ERROR } from "../../../../utils/consts";
import DefaultAlert from "../../../../components/alerts/DefaultAlert";
import Authorities from "../../../../auth/authorities";
import withAuthority from "../../../../components/Auth/withAuthority";
import { Box, Hidden } from "@material-ui/core";
import PageHeaderMobile from "../../../../components/common/PageHeader/PageHeaderMobile";

// 🔥 Firebase imports
import { fetchAlertConfigInfo, fetchDisplayInfo } from "../../../../services/insightApp/metrics";
import AlertConfigNode from "./AlertConfigNode";

/**
 * AlertConfig Component
 *
 * This component fetches and displays real-time metrics from Firebase
 * based on the selected locationId and updates automatically on DB changes.
 */
const AlertConfig: React.FunctionComponent<{}> = () => {
  const [error, setError] = useState("");
  const [stationNode, setStationNode] = useState<any>({});
  const [alertConfigInfo, setAlertConfigInfo] = useState<any>({});
  const [isLoading, setIsLoading] = useState(true);
  const [locationMetricsLoading, setLocationMetricsLoading] = useState(true);
  const [clientId, setClientId] = useState("");

  const match: any = useRouteMatch();
  const locationId = match?.params?.locationId;

  const getAlertConfigInfo = async () => {
    try {
      const res = await fetchAlertConfigInfo(locationId);
      setAlertConfigInfo(res.data.data)
      setIsLoading(false)
    } catch (error) {
        setIsLoading(false)
      setError("Please try again later.");
    }
  };

  const getStationInfo = async () => {
    try {
      // Retrieve the idToken from cookies
      // Fetch all locations using the idToken
      const res = await fetchDisplayInfo(locationId);
      setStationNode(res.data.data)
      getAlertConfigInfo()
    //   if (res?.data?.data?.clientId) {
    //     const clientIdFromApi = res.data.data.clientId;
    //     setClientId(clientIdFromApi);
    //   }
    } catch (error) {
        setIsLoading(false)
      setError("Please try again later.");
    }
  };

  useEffect(() => {
    document.title = "Insight - Alert Configuration";

    getStationInfo();
  }, [locationId]);

  return (
    <>
      <Hidden lgUp>
        <PageHeaderMobile />
      </Hidden>
      <Box style={{ marginTop: "18px" }}>
        <AlertConfigNode
          isLoading={isLoading}
          stationNode={stationNode}
          alertConfigInfo={alertConfigInfo}
          getAlertConfigInfo={getAlertConfigInfo}
          setAlertConfigInfo={setAlertConfigInfo}
        />
      </Box>
      <DefaultAlert
        open={!!error}
        handleClose={() => setError("")}
        message={error}
        severity="error"
      />
    </>
  );
};

export default withAuthority(AlertConfig, Authorities.CUSTOMER_LIST_READ);
